import React, { createContext } from 'react'
import { useHistory } from 'react-router-dom'
import ListingServices from '../Services/Consumers/ListingServices'
import { useKeycloak } from '@react-keycloak/web'
import { useIntl } from 'react-intl'
import { handleNotificationAlert } from '../utils/helpers'
import {
  InvoicesListingParamsPayload,
  InvoiceActionPayload,
  MsInvoicesListingParamsPayload
} from '../Services/Payloads/InvoicePayload'
import { NamedRoutes } from '../routes'
// import moment from 'moment'

const InvoicesListingContext = createContext({})

const InvoicesListingProvider = ({ hasSubscription, list, listArr, loadListExternal, isSingle, loadSingle, filter, isMs, children }) => {
  let history = useHistory()
  const { keycloak } = useKeycloak()
  const intl = useIntl()
  const [isDialogOpen, setIsDialogOpen] = React.useState(false)

  React.useEffect(() => {
    if (!isSingle && !!hasSubscription) {
      setListingPage(0)
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [hasSubscription])

  const [listingRowsPerPage, setListingRowsPerPage] = React.useState(10)
  const [listingLoading, setListingLoading] = React.useState(false)
  const [listingData, setListingData] = React.useState([])
  const [currentSelectedRow, setCurrentSelectedRow] = React.useState({})
  const [currentDialogAction, setCurrentDialogAction] = React.useState('')
  const [listingPage, setListingPage] = React.useState(-1)
  const [listingCount, setListingCount] = React.useState(0)
  const [listingFiltersBackup, setListingFiltersBackup] = React.useState(filter || null)
  const [invoiceTypeFilterBackup, setInvoiceTypeFilterBackup] = React.useState({})


  const handleListingFilterSubmit = (values, FormikActions) => {
    if (!!values && typeof values === 'object') {
      if (!!values.spStatus) {
        setInvoiceTypeFilterBackup({})
      }
      setListingFiltersBackup({ ...filter, ...values })
    }
  }
  const handleInvoiceTypeFilterSubmit = (value) => {

    if (!!value) {
      // tabValue  indicates SP or E-invoice (MS)  0=== SP   and  1=== E-invoice (MS)
      switch (tabValue) {
        case 0:
          setInvoiceTypeFilterBackup({ 'spStatus': value })
          setListingFiltersBackup({ ...listingFiltersBackup, 'spStatus': null })
          break
        case 1:
          setInvoiceTypeFilterBackup({ 'direction': value })
          if (value !== 'sent' && invoiceTypeFilterBackup?.direction === 'sent' && !!listingFiltersBackup?.receiverType) {
            let newFilters = { ...listingFiltersBackup }
            delete newFilters?.receiverType
            setListingFiltersBackup(newFilters)
          }
          break
        default:
          break
      }
    } else {

      setInvoiceTypeFilterBackup({})
    }
  }


  React.useEffect(() => {
    if (!!filter && !!Object.keys(filter || {}).length) {
      setListingFiltersBackup(filter)
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [filter])

  const prevListingRowsPerPage = React.useRef(listingRowsPerPage)

  React.useEffect(() => {
    if (!isSingle && listingPage > -1 && !!hasSubscription && tabValue === 0) {
      getListingData()
    } else if (!isSingle && listingPage > -1 && !!hasSubscription && tabValue === 1) {
      if (listingRowsPerPage !== prevListingRowsPerPage.current) {
        getListingMsInvoiceData(true) // Call getListingMsInvoiceData with resetToken=true
        prevListingRowsPerPage.current = listingRowsPerPage
      } else {
        getListingMsInvoiceData()
      }
      // console.log('rows changed')
      // getListingMsInvoiceData()
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [listingPage, listingRowsPerPage])

  const handleChangeListingPage = (newPage) => {
    setListingPage(newPage)
  }

  const handleChangeListingRowsPerPage = (newRows) => {
    setListingRowsPerPage(+newRows)
    setListingPage(0)
  }

  const getListingData = () => {
    // setListingData([
    //   {
    //     'publicUrl': 'https://preprod.invoicing.eta.gov.eg/documents/A6JXQMH9VWJDBDGB8GTYZE5G10/share/FD4BYDVQN92KVKCW9GTYZE5G10pyJP5l1655139428',
    //     'uuid': 'A6JXQMH9VWJDBDGB8GTYZE5G10',
    //     'submissionUUID': 'P791FJR5NGFE7F1W8GTYZE5G10',
    //     'longId': 'FD4BYDVQN92KVKCW9GTYZE5G10pyJP5l1655139428',
    //     'internalId': '1000009925032',
    //     'typeName': 'I',
    //     'documentTypeNamePrimaryLang': 'Invoice',
    //     'documentTypeNameSecondaryLang': 'فاتورة',
    //     'typeVersionName': '1.0',
    //     'issuerId': '628787103',
    //     'issuerName': 'Mo Ali',
    //     'receiverId': '10201020102',
    //     'receiverName': 'Reciver Man',
    //     'dateTimeIssued': '2022-06-11T00:00:45Z',
    //     'dateTimeReceived': '2022-06-13T16:57:20.107399Z',
    //     'totalSales': 500,
    //     'totalDiscount': 0,
    //     'netAmount': 500,
    //     'total': 500,
    //     'maxPercision': 0,
    //     'invoiceLineItemCodes': null,
    //     'cancelRequestDate': null,
    //     'rejectRequestDate': null,
    //     'cancelRequestDelayedDate': null,
    //     'rejectRequestDelayedDate': null,
    //     'declineCancelRequestDate': null,
    //     'declineRejectRequestDate': null,
    //     'documentStatusReason': '',
    //     'status': 'Valid',
    //     'createdByUserId': '628787103:016c8bba-4b7e-4b3a-9b06-487faddc650c'
    //   },
    //   {
    //     'publicUrl': 'https://preprod.invoicing.eta.gov.eg/documents/RV8WWWS0W483F964NSNYZE5G10/share/CYT3807ZZVX8B7WVNSNYZE5G10qCFsYT1655139424',
    //     'uuid': 'RV8WWWS0W483F964NSNYZE5G10',
    //     'submissionUUID': '61KAS8Z6B1DF8Q8PMSNYZE5G10',
    //     'longId': 'CYT3807ZZVX8B7WVNSNYZE5G10qCFsYT1655139424',
    //     'internalId': '1000009925033',
    //     'typeName': 'I',
    //     'documentTypeNamePrimaryLang': 'Invoice',
    //     'documentTypeNameSecondaryLang': 'فاتورة',
    //     'typeVersionName': '1.0',
    //     'issuerId': '628787103',
    //     'issuerName': 'Mo Ali',
    //     'receiverId': '10201020102',
    //     'receiverName': 'Reciver Man',
    //     'dateTimeIssued': '2022-06-11T00:00:45Z',
    //     'dateTimeReceived': '2022-06-13T16:57:16.9435186Z',
    //     'totalSales': 500,
    //     'totalDiscount': 0,
    //     'netAmount': 500,
    //     'total': 500,
    //     'maxPercision': 0,
    //     'invoiceLineItemCodes': null,
    //     'cancelRequestDate': null,
    //     'rejectRequestDate': null,
    //     'cancelRequestDelayedDate': null,
    //     'rejectRequestDelayedDate': null,
    //     'declineCancelRequestDate': null,
    //     'declineRejectRequestDate': null,
    //     'documentStatusReason': '',
    //     'status': 'Valid',
    //     'createdByUserId': '628787103:016c8bba-4b7e-4b3a-9b06-487faddc650c'
    //   },
    //   {
    //     'publicUrl': 'https://preprod.invoicing.eta.gov.eg/documents/VQSZC61DSW07ZXQEVCKYZE5G10/share/M6MBXA07YPCCPC9QVCKYZE5G10TidqY01655139421',
    //     'uuid': 'VQSZC61DSW07ZXQEVCKYZE5G10',
    //     'submissionUUID': 'JAG1ZRH1M54EVYRPVCKYZE5G10',
    //     'longId': 'M6MBXA07YPCCPC9QVCKYZE5G10TidqY01655139421',
    //     'internalId': '1000009925032',
    //     'typeName': 'I',
    //     'documentTypeNamePrimaryLang': 'Invoice',
    //     'documentTypeNameSecondaryLang': 'فاتورة',
    //     'typeVersionName': '1.0',
    //     'issuerId': '628787103',
    //     'issuerName': 'Mo Ali',
    //     'receiverId': '10201020102',
    //     'receiverName': 'Reciver Man',
    //     'dateTimeIssued': '2022-06-11T00:00:45Z',
    //     'dateTimeReceived': '2022-06-13T16:57:14.4866508Z',
    //     'totalSales': 500,
    //     'totalDiscount': 0,
    //     'netAmount': 500,
    //     'total': 500,
    //     'maxPercision': 0,
    //     'invoiceLineItemCodes': null,
    //     'cancelRequestDate': null,
    //     'rejectRequestDate': null,
    //     'cancelRequestDelayedDate': null,
    //     'rejectRequestDelayedDate': null,
    //     'declineCancelRequestDate': null,
    //     'declineRejectRequestDate': null,
    //     'documentStatusReason': '',
    //     'status': 'Valid',
    //     'createdByUserId': '628787103:016c8bba-4b7e-4b3a-9b06-487faddc650c'
    //   },
    //   {
    //     'publicUrl': 'https://preprod.invoicing.eta.gov.eg/documents/P32TZGW25D5ZY1S79GTYZE5G10/share/GSRVF5DW9939NH0M9GTYZE5G10hTepx51655139428',
    //     'uuid': 'P32TZGW25D5ZY1S79GTYZE5G10',
    //     'submissionUUID': 'P791FJR5NGFE7F1W8GTYZE5G10',
    //     'longId': 'GSRVF5DW9939NH0M9GTYZE5G10hTepx51655139428',
    //     'internalId': '1000009925033',
    //     'typeName': 'I',
    //     'documentTypeNamePrimaryLang': 'Invoice',
    //     'documentTypeNameSecondaryLang': 'فاتورة',
    //     'typeVersionName': '1.0',
    //     'issuerId': '628787103',
    //     'issuerName': 'Mo Ali',
    //     'receiverId': '10201020102',
    //     'receiverName': 'Reciver Man',
    //     'dateTimeIssued': '2022-06-11T00:00:45Z',
    //     'dateTimeReceived': '2022-06-13T16:57:09.9443002Z',
    //     'totalSales': 500,
    //     'totalDiscount': 0,
    //     'netAmount': 500,
    //     'total': 500,
    //     'maxPercision': 0,
    //     'invoiceLineItemCodes': null,
    //     'cancelRequestDate': null,
    //     'rejectRequestDate': null,
    //     'cancelRequestDelayedDate': null,
    //     'rejectRequestDelayedDate': null,
    //     'declineCancelRequestDate': null,
    //     'declineRejectRequestDate': null,
    //     'documentStatusReason': '',
    //     'status': 'Valid',
    //     'createdByUserId': '628787103:016c8bba-4b7e-4b3a-9b06-487faddc650c'
    //   },
    //   {
    //     'publicUrl': 'https://preprod.invoicing.eta.gov.eg/documents/6XGBM5YS4TMHB3H34HRYZE5G10/share/5E963CMC250FD7HK4HRYZE5G10WySyWI1655139426',
    //     'uuid': '6XGBM5YS4TMHB3H34HRYZE5G10',
    //     'submissionUUID': 'QPNHFE21XY6H5MFA4HRYZE5G10',
    //     'longId': '5E963CMC250FD7HK4HRYZE5G10WySyWI1655139426',
    //     'internalId': '1000009925032',
    //     'typeName': 'I',
    //     'documentTypeNamePrimaryLang': 'Invoice',
    //     'documentTypeNameSecondaryLang': 'فاتورة',
    //     'typeVersionName': '1.0',
    //     'issuerId': '628787103',
    //     'issuerName': 'Mo Ali',
    //     'receiverId': '10201020102',
    //     'receiverName': 'Reciver Man',
    //     'dateTimeIssued': '2022-06-11T00:00:45Z',
    //     'dateTimeReceived': '2022-06-13T16:57:07.8245152Z',
    //     'totalSales': 500,
    //     'totalDiscount': 0,
    //     'netAmount': 500,
    //     'total': 500,
    //     'maxPercision': 0,
    //     'invoiceLineItemCodes': null,
    //     'cancelRequestDate': null,
    //     'rejectRequestDate': null,
    //     'cancelRequestDelayedDate': null,
    //     'rejectRequestDelayedDate': null,
    //     'declineCancelRequestDate': null,
    //     'declineRejectRequestDate': null,
    //     'documentStatusReason': '',
    //     'status': 'Valid',
    //     'createdByUserId': '628787103:016c8bba-4b7e-4b3a-9b06-487faddc650c'
    //   },
    //   {
    //     'publicUrl': 'https://preprod.invoicing.eta.gov.eg/documents/SH36CWR2832WRR0F4HRYZE5G10/share/VBNSK50RBKVY3GEV4HRYZE5G109PqiGv1655139426',
    //     'uuid': 'SH36CWR2832WRR0F4HRYZE5G10',
    //     'submissionUUID': 'QPNHFE21XY6H5MFA4HRYZE5G10',
    //     'longId': 'VBNSK50RBKVY3GEV4HRYZE5G109PqiGv1655139426',
    //     'internalId': '1000009925033',
    //     'typeName': 'I',
    //     'documentTypeNamePrimaryLang': 'Invoice',
    //     'documentTypeNameSecondaryLang': 'فاتورة',
    //     'typeVersionName': '1.0',
    //     'issuerId': '628787103',
    //     'issuerName': 'Mo Ali',
    //     'receiverId': '10201020102',
    //     'receiverName': 'Reciver Man',
    //     'dateTimeIssued': '2022-06-11T00:00:45Z',
    //     'dateTimeReceived': '2022-06-13T16:57:07.3863548Z',
    //     'totalSales': 500,
    //     'totalDiscount': 0,
    //     'netAmount': 500,
    //     'total': 500,
    //     'maxPercision': 0,
    //     'invoiceLineItemCodes': null,
    //     'cancelRequestDate': null,
    //     'rejectRequestDate': null,
    //     'cancelRequestDelayedDate': null,
    //     'rejectRequestDelayedDate': null,
    //     'declineCancelRequestDate': null,
    //     'declineRejectRequestDate': null,
    //     'documentStatusReason': '',
    //     'status': 'Valid',
    //     'createdByUserId': '628787103:016c8bba-4b7e-4b3a-9b06-487faddc650c'
    //   },
    //   {
    //     'publicUrl': 'https://preprod.invoicing.eta.gov.eg/documents/AE0EPJPGRCRNH5HSNSNYZE5G10/share/KJ8JZ7V8FGKTN080NSNYZE5G10o27Xuy1655139424',
    //     'uuid': 'AE0EPJPGRCRNH5HSNSNYZE5G10',
    //     'submissionUUID': '61KAS8Z6B1DF8Q8PMSNYZE5G10',
    //     'longId': 'KJ8JZ7V8FGKTN080NSNYZE5G10o27Xuy1655139424',
    //     'internalId': '1000009925032',
    //     'typeName': 'I',
    //     'documentTypeNamePrimaryLang': 'Invoice',
    //     'documentTypeNameSecondaryLang': 'فاتورة',
    //     'typeVersionName': '1.0',
    //     'issuerId': '628787103',
    //     'issuerName': 'Mo Ali',
    //     'receiverId': '10201020102',
    //     'receiverName': 'Reciver Man',
    //     'dateTimeIssued': '2022-06-11T00:00:45Z',
    //     'dateTimeReceived': '2022-06-13T16:57:05.9415232Z',
    //     'totalSales': 500,
    //     'totalDiscount': 0,
    //     'netAmount': 500,
    //     'total': 500,
    //     'maxPercision': 0,
    //     'invoiceLineItemCodes': null,
    //     'cancelRequestDate': null,
    //     'rejectRequestDate': null,
    //     'cancelRequestDelayedDate': null,
    //     'rejectRequestDelayedDate': null,
    //     'declineCancelRequestDate': null,
    //     'declineRejectRequestDate': null,
    //     'documentStatusReason': '',
    //     'status': 'Valid',
    //     'createdByUserId': '628787103:016c8bba-4b7e-4b3a-9b06-487faddc650c'
    //   },
    //   {
    //     'publicUrl': 'https://preprod.invoicing.eta.gov.eg/documents/A56VMGWRZKDR0BEFVCKYZE5G10/share/JM8HEB4YDRXJVDY3WCKYZE5G10rcXGAz1655139421',
    //     'uuid': 'A56VMGWRZKDR0BEFVCKYZE5G10',
    //     'submissionUUID': 'JAG1ZRH1M54EVYRPVCKYZE5G10',
    //     'longId': 'JM8HEB4YDRXJVDY3WCKYZE5G10rcXGAz1655139421',
    //     'internalId': '1000009925033',
    //     'typeName': 'I',
    //     'documentTypeNamePrimaryLang': 'Invoice',
    //     'documentTypeNameSecondaryLang': 'فاتورة',
    //     'typeVersionName': '1.0',
    //     'issuerId': '628787103',
    //     'issuerName': 'Mo Ali',
    //     'receiverId': '10201020102',
    //     'receiverName': 'Reciver Man',
    //     'dateTimeIssued': '2022-06-11T00:00:45Z',
    //     'dateTimeReceived': '2022-06-13T16:57:03.8772958Z',
    //     'totalSales': 500,
    //     'totalDiscount': 0,
    //     'netAmount': 500,
    //     'total': 500,
    //     'maxPercision': 0,
    //     'invoiceLineItemCodes': null,
    //     'cancelRequestDate': null,
    //     'rejectRequestDate': null,
    //     'cancelRequestDelayedDate': null,
    //     'rejectRequestDelayedDate': null,
    //     'declineCancelRequestDate': null,
    //     'declineRejectRequestDate': null,
    //     'documentStatusReason': '',
    //     'status': 'Valid',
    //     'createdByUserId': '628787103:016c8bba-4b7e-4b3a-9b06-487faddc650c'
    //   },
    //   {
    //     'publicUrl': 'https://preprod.invoicing.eta.gov.eg/documents/8MKGNBR8Q6MYCQZHXVFYZE5G10/share/AQ444Z338314Q0FYXVFYZE5G10qFlsvz1655139417',
    //     'uuid': '8MKGNBR8Q6MYCQZHXVFYZE5G10',
    //     'submissionUUID': 'C0D8Q78RYPPQVGN1XVFYZE5G10',
    //     'longId': 'AQ444Z338314Q0FYXVFYZE5G10qFlsvz1655139417',
    //     'internalId': '1000009925033',
    //     'typeName': 'I',
    //     'documentTypeNamePrimaryLang': 'Invoice',
    //     'documentTypeNameSecondaryLang': 'فاتورة',
    //     'typeVersionName': '1.0',
    //     'issuerId': '628787103',
    //     'issuerName': 'Mo Ali',
    //     'receiverId': '10201020102',
    //     'receiverName': 'Reciver Man',
    //     'dateTimeIssued': '2022-06-11T00:00:45Z',
    //     'dateTimeReceived': '2022-06-13T16:57:00.5186342Z',
    //     'totalSales': 500,
    //     'totalDiscount': 0,
    //     'netAmount': 500,
    //     'total': 500,
    //     'maxPercision': 0,
    //     'invoiceLineItemCodes': null,
    //     'cancelRequestDate': null,
    //     'rejectRequestDate': null,
    //     'cancelRequestDelayedDate': null,
    //     'rejectRequestDelayedDate': null,
    //     'declineCancelRequestDate': null,
    //     'declineRejectRequestDate': null,
    //     'documentStatusReason': '',
    //     'status': 'Valid',
    //     'createdByUserId': '628787103:016c8bba-4b7e-4b3a-9b06-487faddc650c'
    //   },
    //   {
    //     'publicUrl': 'https://preprod.invoicing.eta.gov.eg/documents/P9WZQFQTZSH3SQRHXVFYZE5G10/share/DH4YM24EFQRRW8HAXVFYZE5G10gx4QP41655139417',
    //     'uuid': 'P9WZQFQTZSH3SQRHXVFYZE5G10',
    //     'submissionUUID': 'C0D8Q78RYPPQVGN1XVFYZE5G10',
    //     'longId': 'DH4YM24EFQRRW8HAXVFYZE5G10gx4QP41655139417',
    //     'internalId': '1000009925032',
    //     'typeName': 'I',
    //     'documentTypeNamePrimaryLang': 'Invoice',
    //     'documentTypeNameSecondaryLang': 'فاتورة',
    //     'typeVersionName': '1.0',
    //     'issuerId': '628787103',
    //     'issuerName': 'Mo Ali',
    //     'receiverId': '10201020102',
    //     'receiverName': 'Reciver Man',
    //     'dateTimeIssued': '2022-06-11T00:00:45Z',
    //     'dateTimeReceived': '2022-06-13T16:56:59.895595Z',
    //     'totalSales': 500,
    //     'totalDiscount': 0,
    //     'netAmount': 500,
    //     'total': 500,
    //     'maxPercision': 0,
    //     'invoiceLineItemCodes': null,
    //     'cancelRequestDate': null,
    //     'rejectRequestDate': null,
    //     'cancelRequestDelayedDate': null,
    //     'rejectRequestDelayedDate': null,
    //     'declineCancelRequestDate': null,
    //     'declineRejectRequestDate': null,
    //     'documentStatusReason': '',
    //     'status': 'Valid',
    //     'createdByUserId': '628787103:016c8bba-4b7e-4b3a-9b06-487faddc650c'
    //   }
    // ])
    // setListingCount(10)
    if (!!keycloak?.authenticated) {
      setListingLoading(true)
      if (!!listArr && !!list) {
        setListingCount(listArr?.length)
        setListingData(listArr)
        setTimeout(() => setListingLoading(false), 300)
      } else {
        ListingServices.getInvoicesListingData(InvoicesListingParamsPayload(listingPage + 1, listingRowsPerPage, {
          ...listingFiltersBackup, ...invoiceTypeFilterBackup
        }, list),
          intl.formatMessage({ id: `listing.Error.invoices` })).then((result) => {
            if (!!result && !!result.data && !!result.data.result) {
              setListingCount(result.data.metadata.totalCount)
              setListingData(result?.data?.result)
            }
          }).then(() => {
            setListingLoading(false)
          })
      }
    }
  }

  const [listingLoadingEInvoice, setListingLoadingEInvoice] = React.useState(false)
  const [listingDataEnvoice, setListingDataEnvoice] = React.useState([])
  const [tabValue, setTabValue] = React.useState(0)
  const [tabEntityName, setTabEntityName] = React.useState('sp')
  const [continuationTokens, setContinuationTokens] = React.useState([''])
  const [currentIndex, setCurrentIndex] = React.useState(0)
  const getListingMsInvoiceData = (resetToken = false) => {
    if (!!keycloak?.authenticated) {
      setListingLoadingEInvoice(true)
      // if (!!listArr && !!list) {
      //   setListingCount(listArr?.length)
      //   setListingData(listArr)
      //   setTimeout(() => setListingLoadingEInvoice(false), 300)
      // } else {
      let currentIndexTemp = currentIndex
      if (resetToken) {
        currentIndexTemp = 0
        setContinuationTokens([''])
        setCurrentIndex(0)
        setListingPage(0)

      }

      ListingServices.getEInvoicesListingData(MsInvoicesListingParamsPayload(continuationTokens[currentIndexTemp], listingRowsPerPage, { ...listingFiltersBackup, ...invoiceTypeFilterBackup }, list),
        intl.formatMessage({ id: `listing.Error.invoices` }), intl.formatMessage({ id: `listing.Error.401.invoices` })).then((result) => {
          if (!!result && !!result.data && !!result.data.result) {
            // console.log('[...continuationToken',[...continuationTokens.slice(0, currentIndex + 1), result.data.metadata.continuationToken.replace('|','%7C')])
            setContinuationTokens([...continuationTokens.slice(0, currentIndex + 1), result.data.metadata.continuationToken.replace('|', '%7C')])
            setListingDataEnvoice(result.data.result)
          } else {
            setListingDataEnvoice([])
          }
        }).then(() => {
          setListingLoadingEInvoice(false)
        })

      // }
    }
  }

  const handleTokenPagination = (direction) => {


    if (direction === 'next' && currentIndex < continuationTokens.length - 1) {
      setCurrentIndex(currentIndex + 1)
      setListingPage(listingPage + 1)
    } else if (direction === 'previous' && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1)
      setListingPage(listingPage - 1)
      // getListingMsInvoiceData()
    }
  }


  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
    setListingPage(0)
    setListingRowsPerPage(10)
    setListingFiltersBackup(null)
    setInvoiceTypeFilterBackup({})
    switch (newValue) {
      case 0:   // Sp invoice
        if (!isSingle && listingPage > -1 && !!hasSubscription) {
          setTabEntityName('sp')
          // getListingData()
        }
        break
      case 1:   // E-Invoice invoice
        if (!isSingle && listingPage > -1 && !!hasSubscription) {
          setTabEntityName('eInvoice')
        }
        break
      default:
        break
    }
  }

  React.useEffect(() => {
    if (tabValue === 1 && !!hasSubscription) {
      getListingMsInvoiceData(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps  
  }, [tabValue, listingFiltersBackup, invoiceTypeFilterBackup])

  React.useEffect(() => {
    if (!isSingle && !!hasSubscription) {
      // tab value 0 means SP in order to call the api only in tab SP
      if (listingPage === 0 && tabValue === 0) {
        getListingData()
      }
      setListingPage(0)
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [listingFiltersBackup, invoiceTypeFilterBackup, listArr, tabValue])


  const [downloadLoading, setDownloadLoading] = React.useState(false)
  const [downloadLoadingProgress, setDownloadLoadingProgress] = React.useState(0)
  const downloadInvoice = (type, id, msId, isMs = false) => {
    if (!!keycloak?.authenticated) {
      let extension = 'json'
      let blobType = 'text/json'
      switch (type) {
        case 'download-pdf':
        case 'print':
          extension = 'pdf'
          blobType = 'application/pdf'
          break
        case 'download-json':
          extension = 'json'
          blobType = 'text/json'
          break
        case 'download-xml':
          extension = 'xml'
          blobType = 'text/xml'
          break
        default:
          break
      }
      setDownloadLoading(true)
      if ((isMs || tabValue === 1) && !['download-pdf', 'print'].includes(type)) {
        ListingServices.getMsInvoiceDownloadData(type, id, setDownloadLoadingProgress, intl.formatMessage({ id: `listing.Invoices.Error.action.${type}` }, { uuid: id }), (type === 'download-pdf') ? intl.formatMessage({ id: `listing.Invoices.Error.action.download-pdf.404` }, { uuid: id }) : '').then((result) => {
          if (!!result && !!result.data) {
            let data = result.data
            if (type === 'download-xml') {
              if (!!data['document']) {
                data['document'] = JSON.parse(data['document'])
              }
              data = OBJtoXML({ document: result.data })
            } else if (type === 'download-json') {
              if (!!data['document']) {
                data['document'] = JSON.parse(data['document'])
              }
              data = JSON.stringify(data, null, 2)
            }

            const blob = new Blob([data], { type: blobType, encoding: 'UTF-8' })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            const contentDisposition = result.headers['content-disposition']
            let fileName = `${intl.formatMessage({ id: 'listing.Invoices.download.fileName' })}-${id}.${extension}`
            if (contentDisposition) {
              const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
              if (fileNameMatch.length === 2)
                fileName = fileNameMatch[1]
            }
            link.setAttribute('download', fileName) //or any other extension
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(url)
          }
        }).then(() => {
          setDownloadLoading(false)
          setCurrentDialogAction('')
          setTimeout(() => setDownloadLoadingProgress(0), 200)
        })
      } else {
        ListingServices.getInvoiceDownloadData(type, id, setDownloadLoadingProgress, intl.formatMessage({ id: `listing.Invoices.Error.action.${type}` }, { uuid: id }), (type === 'download-pdf') ? intl.formatMessage({ id: `listing.Invoices.Error.action.download-pdf.404` }, { uuid: id }) : '').then((result) => {
          if (!!result && !!result.data) {
            let data = result.data
            if (type === 'download-xml') {
              if (!!data['document']) {
                data['document'] = JSON.parse(data['document'])
              }
              data = OBJtoXML({ document: result.data })
            } else if (type === 'download-json') {
              if (!!data['document']) {
                data['document'] = JSON.parse(data['document'])
              }
              data = JSON.stringify(data, null, 2)
            }

            const blob = new Blob([data], { type: blobType, encoding: 'UTF-8' })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            const contentDisposition = result.headers['content-disposition']
            let fileName = `${intl.formatMessage({ id: 'listing.Invoices.download.fileName' })}-${id}.${extension}`
            if (contentDisposition) {
              const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
              if (fileNameMatch.length === 2)
                fileName = fileNameMatch[1]
            }
            if (type === 'print') {
              window.open(url, '_blank') //or any other extension
            } else {
              link.setAttribute('download', fileName) //or any other extension
              document.body.appendChild(link)
              link.click()
              link.remove()
              window.URL.revokeObjectURL(url)
            }
          }
        }).then(() => {
          setDownloadLoading(false)
          setCurrentDialogAction('')
          setTimeout(() => setDownloadLoadingProgress(0), 200)
        })
      }
    }
  }

  const OBJtoXML = (obj) => {
    let xml = ''
    for (let prop in obj) {
      xml += obj[prop] instanceof Array ? '' : '<' + prop + (!(obj[prop] == null || obj[prop].length === 0) ? '>' : ' />')
      if (!(obj[prop] == null || obj[prop].length === 0)) {
        if (obj[prop] instanceof Array) {
          for (let array in obj[prop]) {
            xml += '<' + prop + '>'
            // eslint-disable-next-line no-new-object
            xml += OBJtoXML(new Object(obj[prop][array]))
            xml += '</' + prop + '>'
          }
        } else if (typeof obj[prop] == 'object') {
          // eslint-disable-next-line no-new-object
          xml += OBJtoXML(new Object(obj[prop]))
        } else {
          xml += obj[prop]
        }
        xml += obj[prop] instanceof Array ? '' : '</' + prop + '>'
      }
    }
    if (!!xml) {
      xml = xml.replace(/<\/?[0-9]{1,}>/g, '')
      xml = formatXml(xml)
    }

    return xml
  }

  function formatXml(xml) {
    let formatted = ''
    let reg = /(>)(<)(\/*)/g
    xml = xml.replace(reg, '$1\r\n$2$3')
    let pad = 0
    xml.split('\r\n').forEach((node, index) => {
      let indent = 0
      if (node.match(/.+<\/\w[^>]*>$/)) {
        indent = 0
      } else if (node.match(/^<\/\w/)) {
        if (pad !== 0) {
          pad -= 1
        }
      } else if (node.match(/^<\w[^>]*[^/]>.*$/)) {
        indent = 1
      } else {
        indent = 0
      }

      let padding = ''
      for (let i = 0; i < pad; i++) {
        padding += '  '
      }

      formatted += padding + node + '\r\n'
      pad += indent
    })

    return formatted
  }

  const [actionItemLoading, setActionItemLoading] = React.useState(false)
  const dialogActionSubmit = (values, FormikActions, closeConfirmDialog) => {
    if (!!keycloak?.authenticated) {
      setActionItemLoading(true)
      ListingServices.handleActionDialogSubmit(currentDialogAction, InvoiceActionPayload(currentDialogAction, values), currentSelectedRow?.uuid?.toString() || '',
        setActionItemLoading, FormikActions,
        intl.formatMessage({ id: `listing.Invoices.Error.action.${currentDialogAction}` }), intl.formatMessage({ id: `listing.Invoices.Error.401.action` })).then((result) => {
          if (!!result && ((!!result.data && !!result.data.data) || ['200', '201', '204'].includes(result.status.toString()))) {
            handleNotificationAlert({
              type: 'done',
              message: intl.formatMessage({ id: `listing.Invoices.Success.action.${currentDialogAction}` }, currentSelectedRow?.uuid?.toString()),
              color: 'success'
            }, 'success')
            if (!!FormikActions) {
              FormikActions.setSubmitting(false)
            }
            /** Close Dialog**/
            if (!!listArr && !!list) {
              cancelDialog()
              if (!!loadListExternal) {
                setTimeout(() => {
                  loadListExternal()
                }, 500)
              }
            } else {
              if (!!isSingle && !!hasSubscription) {
                if (!!isMs) {
                  cancelDialog()
                  setTimeout(() => !!loadSingle && loadSingle(), 300)
                } else {
                  !!loadSingle && loadSingle()
                }
              } else {
                if (!!closeConfirmDialog) {
                  closeConfirmDialog()
                  setTimeout(() => cancelDialog(), 200)
                } else {
                  cancelDialog()
                }
                /** Reload Listing after Add/Edit/Delete**/
                setTimeout(() => {
                  if (tabValue === 1) getListingMsInvoiceData(true)
                  else getListingData()
                }, 500)
              }
            }
          }
        }).then(() => {
          setActionItemLoading(false)
          if (!!FormikActions) {
            FormikActions.setSubmitting(false)
          }
        })
    }
  }


  const openDialog = (type, selectedRow, id, handleMenuClose, msId, isMs = false) => {
    if (!!handleMenuClose) {
      handleMenuClose()
    }
    if (['download-pdf', 'download-json', 'download-xml'].includes(type)) {
      downloadInvoice(type, id, msId, isMs)
    } else if ('print' === type) {
      downloadInvoice('print', id, msId, isMs)
      // let pubURL = new URL(selectedRow?.publicUrl)
      // let url = pubURL.origin + `/print/documents/${selectedRow?.uuid}`
      // window.open(url, '_blank')
    } else if (['create-credit-note', 'create-debit-note'].includes(type)) {
      let exportLetter = ''
      if (selectedRow?.typeName?.toLowerCase() === 'ei') {
        exportLetter = 'E'
      }
      setTimeout(() => history.push({
        pathname: NamedRoutes.newInvoice,
        state: { createNote: { type: type === 'create-credit-note' ? `${exportLetter}C` : `${exportLetter}D`, reference: selectedRow?.uuid } }
      }), 300)
    } else if ('create-copy' === type) {
      setTimeout(() => history.push(`${NamedRoutes.newInvoice}?invoiceUUID=${selectedRow?.uuid}`), 300)
    } else {
      setCurrentSelectedRow(selectedRow || {})
      setIsDialogOpen(!isDialogOpen)
    }
    setCurrentDialogAction(type || 'create')
  }

  const cancelDialog = () => {
    setIsDialogOpen(false)
  }

  return (
    <InvoicesListingContext.Provider value={{
      listingData,
      listingLoading,

      listingCount,
      listingRowsPerPage,
      listingPage,
      continuationTokens,
      currentIndex,
      listingFiltersBackup,
      handleChangeListingPage,
      handleChangeListingRowsPerPage,
      handleTokenPagination,

      handleListingFilterSubmit,
      handleInvoiceTypeFilterSubmit,
      invoiceTypeFilterBackup,

      isDialogOpen,
      openDialog,
      cancelDialog,

      listingLoadingEInvoice,
      tabValue,
      listingDataEnvoice,
      tabEntityName,
      handleTabChange,

      currentSelectedRow,
      currentDialogAction,
      dialogActionSubmit,
      actionItemLoading,
      downloadLoading,
      downloadLoadingProgress

    }}>
      {children}
    </InvoicesListingContext.Provider>
  )
}
const InvoicesListingConsumer = InvoicesListingContext.Consumer

export { InvoicesListingProvider, InvoicesListingConsumer }
